<template>
    <div>
        <div class="sh-logopanel">
            <a href="" class="sh-logo-text">Zine</a>
            <a id="navicon" href="" class="sh-navicon d-none d-xl-block"><i class="icon ion-navicon"></i></a>
            <a id="naviconMobile" href="" class="sh-navicon d-xl-none"><i class="icon ion-navicon"></i></a>
        </div><!-- sh-logopanel -->

        <div class="sh-sideleft-menu">
            <label class="sh-sidebar-label">Navigation</label>
            <ul class="nav">
                <li class="nav-item">
                    <a href="/dashboard" :class="$route.path == '/dashboard' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-ios-home-outline"></i>
                        <span>Dashboard</span>
                    </a>
                </li><!-- nav-item -->
                <li class="nav-item">
                    <a href="/create-order" :class="$route.path == '/create-order' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-plus"></i>
                        <span>Nieuwe Order</span>
                    </a>
                </li><!-- nav-item -->
                <li class="nav-item">
                    <a href="/orders" :class="$route.path == '/orders' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-ios-search"></i>
                        <span>Orders</span>
                    </a>
                </li><!-- nav-item -->

                <li class="nav-item">
                    <a href="/create-order/creditorder" :class="$route.path == '/create-order/creditorder' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-plus"></i>
                        <span>Nieuwe Creditorder</span>
                    </a>
                </li><!-- nav-item -->
                <li class="nav-item">
                    <a href="/orders/creditorder" :class="$route.path == '/orders/creditorder' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-ios-search"></i>
                        <span>Creditorders</span>
                    </a>
                </li><!-- nav-item -->

                <li class="nav-item">
                    <a href="/combineorders" :class="$route.path == '/combineorders' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-minus"></i>
                        <span>Combineer Orders</span>
                    </a>
                </li><!-- nav-item -->

                <li class="nav-item">
                    <a href="/weborders" :class="$route.path == '/weborders' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-search"></i>
                        <span>Weborders</span>
                    </a>
                </li><!-- nav-item -->

                <li class="nav-item">
                    <a href="/debtors" :class="$route.path == '/debtors' ? 'nav-link active':'nav-link'">
                        <i class="icon ion-person-stalker"></i>
                        <span>Klanten</span>
                    </a>
                </li><!-- nav-item -->

                <!-- <li class="nav-item">
                <a href="" class="nav-link with-sub">
                    <i class="icon ion-ios-bookmarks-outline"></i>
                    <span>Pages</span>
                </a>
                <ul class="nav-sub">
                    <li class="nav-item"><a href="blank.html" class="nav-link">Blank Page</a></li>
                    <li class="nav-item"><a href="page-mailbox.html" class="nav-link">Mailbox</a></li>
                    <li class="nav-item"><a href="page-chat.html" class="nav-link">Chat Page</a></li>
                    <li class="nav-item"><a href="page-calendar.html" class="nav-link">Calendar</a></li>
                    <li class="nav-item"><a href="page-edit-profile.html" class="nav-link">Edit Profile</a></li>
                    <li class="nav-item"><a href="page-file-manager.html" class="nav-link">File Manager</a></li>
                    <li class="nav-item"><a href="page-invoice.html" class="nav-link">Invoice Page</a></li>
                    <li class="nav-item"><a href="page-forum-list.html" class="nav-link">Forum List Page</a></li>
                    <li class="nav-item"><a href="page-forum-topic.html" class="nav-link">Forum Topic View</a></li>
                    <li class="nav-item"><a href="page-signin.html" class="nav-link">Signin Page</a></li>
                    <li class="nav-item"><a href="page-signup.html" class="nav-link">Signup Page</a></li>
                    <li class="nav-item"><a href="page-notfound.html" class="nav-link">404 Page Not Found</a></li>
                </ul>
                </li>  -->
                
            </ul>
        </div><!-- sh-sideleft-menu -->

        <div class="sh-headpanel">
            <div class="sh-headpanel-left">

                <!-- START: HIDDEN IN MOBILE -->
                <a href="/dashboard" class="sh-icon-link">
                <div>
                    <i class="icon ion-ios-home"></i>
                    <span>Home</span>
                </div>
                </a>
                <a href="/create-order" class="sh-icon-link">
                <div>
                    <i class="icon ion-plus"></i>
                    <span>Order</span>
                </div>
                </a>
                <a href="/orders" class="sh-icon-link">
                <div>
                    <i class="icon ion-ios-search"></i>
                    <span>Orders</span>
                </div>
                </a>
                <a href="/create-order/creditorder" class="sh-icon-link">
                <div>
                    <i class="icon ion-plus"></i>
                    <span>Creditorder</span>
                </div>
                </a>
                <a href="/orders/creditorder" class="sh-icon-link">
                <div>
                    <i class="icon ion-ios-search"></i>
                    <span>Creditorders</span>
                </div>
                </a>
                <a href="/debtors" class="sh-icon-link">
                    <div>
                        <i class="icon ion-person-stalker"></i>
                        <span>Klanten</span>
                    </div>
                </a>

                <a href="/combineorders" class="sh-icon-link">
                    <div>
                        <i class="icon ion-minus"></i>
                        <span>Combineer</span>
                    </div>
                </a>

                <a href="/weborders" class="sh-icon-link">
                    <div>
                        <i class="icon ion-search"></i>
                        <span>Weborders</span>
                    </div>
                </a>

                 <a href="https://zine.all4trade.nl/admin" class="sh-icon-link" target="_blank">
                <div>
                    <i class="icon ion-share"></i>
                    <span>Zine</span>
                </div>
                </a>
                <!-- END: HIDDEN IN MOBILE -->

            </div><!-- sh-headpanel-left -->

            <div class="sh-headpanel-right pr-0">
                <a href="#" class="sh-icon-link" @click="logoff()">
                    <div>
                        <i class="icon ion-power"></i>
                        <span>Uitloggen</span>
                    </div>
                </a> 
            </div>
            <!-- sh-headpanel-right -->
        </div><!-- sh-headpanel -->

        <slot></slot>
    
    </div>
</template>

<script>
export default {
    name:'dashboard_layout',
    created(){
        // window.console.log(this.$route);
    },
    methods : {
        logoff(){
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('api_token');
            window.location.href='/login';
        }
    }
}
</script>
